// Module
var code = "<div class=\"dms-form-wrapper dms-outer-element\">\r\n    <div class=\"dms-grid-wrapper dms-form #:data.GridName#\">\r\n    </div>\r\n</div>";
// Exports
export default code;